<template>
	<Navbar/>

	<section id="rules" class="relative py-32">

		<div class="container relative">

			<div class="title grid grid-cols-1 mb-8 text-center">
				<h4 class="uppercase text-4xl font-bold tracking-wider mb-3">Termine</h4>
				<div class="border"></div>
			</div>

			<div class="grid grid-cols-1">
				<div class="block">

					<h5 class="font-semibold mt-5">Verein</h5>
          <table class="table table-striped font-quattrocento py-4">
            <tbody>
              <tr>
                <td>22.02.</td>
                <td class="px-5">16:00 Uhr</td>
                <td>Jahreshauptversammlung - Dat Handorfer Huus</td>
              </tr>
              <tr>
                <td>14.03.</td>
                <td class="px-5">10:00 Uhr</td>
                <td>Arbeitstag am Platz</td>
              </tr>
              <tr>
                <td>17.10.</td>
                <td class="px-5">10:00 Uhr</td>
                <td>Arbeitstag am Platz</td>
              </tr>
            </tbody>
          </table>

          <h5 class="font-semibold mt-5">Turniere/Meisterschaften</h5>
          <table class="table table-striped font-quattrocento">
            <tbody>
              <tr>
                <td>18.04.</td>
                <td class="px-5">Vereinsmeisterschaft WA im Freien</td>
                <td>Münster (bei den Rovers Bogenschützen)</td>
              </tr>
              <tr>
                <td>19.04.</td>
                <td class="px-5">Vereinsmeisterschaft Feldbogen</td>
                <td>Münster (bei den Rovers Bogenschützen)</td>
              </tr>
              <tr>
                <td>03.05.</td>
                <td class="px-5">Bezirksmeisterschaft Feldbogen</td>
                <td>Dorsten</td>
              </tr>
              <tr>
                <td>31.05.</td>
                <td class="px-5">Landesmeisterschaft Feldbogen</td>
                <td>Münster (bei den Rovers Bogenschützen)</td>
              </tr>
              <tr>
                <td>07.06.</td>
                <td class="px-5">Bezirksmeisterschaft WA im Freien</td>
                <td>Bochold</td>
              </tr>
              <tr>
                <td>04.07.</td>
                <td class="px-5">Vereinsmeisterschaft 3D</td>
                <td>Münster</td>
              </tr>
              <tr>
                <td>11.-12.07.</td>
                <td class="px-5">Landesmeisterschaft WA im Freien</td>
                <td>Dortmund</td>
              </tr>
              <tr>
                <td>26.07.</td>
                <td class="px-5">Landesmeisterschaft 3D</td>
                <td>Münster (bei den Rovers Bogenschützen)</td>
              </tr>
              <tr>
                <td>08.-09.09.</td>
                <td class="px-5">Deutsche Meisterschaft Feldbogen</td>
                <td>Kellinghues</td>
              </tr>
            </tbody>
          </table>

				</div>
			</div>

		</div>

	</section>

	<section class="pt-6 bg-dark text-white">
		<Info/>
	</section>

	<Footer/>

	<ScrollToTop/>
</template>

<script setup>
import {onMounted} from "vue";

import {useLoaderState} from "@/store/isloading";

import Navbar from "@/components/layout/navbar.vue";
import Info from "@/components/layout/info.vue";
import Footer from "@/components/layout/footer.vue";
import ScrollToTop from "@/components/scroll-to-top.vue";

const isLoading = useLoaderState();
const { changeStateTrue } = isLoading;

onMounted(() => {
	changeStateTrue();

	setTimeout(() => {
		const { changeStateFalse } = isLoading;
		changeStateFalse();
	}, 1000);
})
</script>
